import { h } from 'preact';
import * as is from 'utilities/is';
import { trackableFetch } from 'utilities/network';
import { Loader } from 'rendering/components/loader';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { ANNOTATION_EVENT, APPLICATION_EVENT } from 'constants/events';

import { InvisibleAnnotation } from 'rendering/components/invisible_annotation';

export class LanguageProvider extends BaseAnnotation {
    constructor(...args) {
        super(...args);
        this.initLoaded();
    }

    initLoaded() {
        this.loadedLanguages = {};
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.lastModified !== this.props.lastModified) {
            this.initLoaded();
            return true;
        }
    }

    render() {
        if (!this.loadedLanguages[this.contents]) {
            this.loadedLanguages[this.contents] = 'loading';
            
            this.loadLanguage(this.contents)
                .then(() => this.eventBus.emit(APPLICATION_EVENT.DEPENDENCIES_LOADING, false))
                .then(() => this.forceUpdate());

            this.eventBus.emit(APPLICATION_EVENT.DEPENDENCIES_LOADING, true);
        }

        const debugAttrs = {
            ['data-annotation']: 'languageprovider',
            ['data-contents']: this.contents
        }

        return <InvisibleAnnotation { ...debugAttrs }/>;
    }

    loadLanguage(url) {
        if (url === null) {
            // null indicates no translations are provided for this language
            this.loadedLanguages[url] = true;            
            return Promise.resolve();
        }

        return (
            trackableFetch(url, { credentials: 'same-origin' })
                .then(res => res.json())
                .then(json => this.loadedLanguages[url] = json)
                .then(() => this.setLanguageContent(url))
                .catch(error => console.error(error))
        )
    }

    setLanguageContent(url, language) {
        requestAnimationFrame(() => {
            const arb = this.loadedLanguages[url];
        
            language = language || arb['@@locale'];
            this.eventBus.emit(ANNOTATION_EVENT.LANGUAGE_LOAD, arb, language);
        })
    }

    get contents() {
        return this.props.content;
    }

    static get schemaType() {
        return 'languageprovider';
    }
}